window.addEventListener('DOMContentLoaded', () => {
  let tabEl = document.getElementById('active_programs_tab')
  if (tabEl) {
    tabEl.addEventListener('shown.bs.tab', () => window.dispatchEvent(new Event('resize')))
  }
})
